<template>
  <div class="dashboard">
    <div class="container">
      <Kits
        v-if="component === 0"
      ></Kits>
    </div>
  </div>
</template>

<script>
import Kits from "./dashboard/LabKits";
export default {
  name: "LabDashboard",
  data() {
    return {
      component: 0,
    }
  },
  components: {
    Kits
  },
  methods: {
  
  },
};
</script>

<style scoped>
.dashboard {
  padding: 140px 0 10px 0;
  background-color: #f4f8f9;
  max-width: 100%;
  width: 100vw;
  min-height: 95vh;
  position: relative;
}
@media print {
  .dashboard {
    min-height: 10vh;
  }
}
</style>